/**
 * @desc 导入
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/allocationPlan/importExcel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
